module.exports = __webpack_public_path__ + "static/media/centro1.3b405e0e.jpg";